<template>
  <div class="person-info-view"
       v-loading="loading">
    <article>
      <div class="cpl">
        <div class="cpl-header">
          <h2>公司信息</h2>
        </div>
        <div class="cpl-body table-wrap">
          <table>
            <tbody>
              <tr>
                <td class="cell-title">统一社会信用代码：</td>
                <td class="cell-value"><span>{{personInfo.enterprise.basicInfo.enterpriseCode}}</span></td>
              </tr>
              <tr>
                <td class="cell-title">企业全称：</td>
                <td class="cell-value"><span>{{personInfo.enterprise.basicInfo.enterpriseName}}</span></td>
              </tr>
              <tr>
                <td class="cell-title">企业办公地址：</td>
                <td class="cell-value"
                    style="position: relative;">
                  <span style="width: 460px;position: absolute;top: 0;left: 0; line-height: 24px;">{{ personInfo.enterprise.basicInfo.address }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="cpl">
        <div class="cpl-header">
          <h2>法定代表人</h2>
        </div>
        <div class="cpl-body table-wrap">
          <table>
            <tbody>
              <tr>
                <td class="cell-title">姓名：</td>
                <td class="cell-value"><span>{{personInfo.enterprise.legalRepresentation.name}}</span></td>
              </tr>
              <tr>
                <td class="cell-title">身份证号：</td>
                <td class="cell-value"><span>{{personInfo.enterprise.legalRepresentation.idNo}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="cpl">
        <div class="cpl-header">
          <h2>联系人信息</h2>
        </div>
        <div class="cpl-body table-wrap">
          <table>
            <tbody>
              <tr>
                <td class="cell-title">姓名：</td>
                <td class="cell-value"><span>{{personInfo.enterprise.contacts.name}}</span></td>
              </tr>
              <tr>
                <td class="cell-title">联系方式：</td>
                <td class="cell-value"><span>{{personInfo.enterprise.contacts.phone}}</span></td>
              </tr>
              <tr>
                <td class="cell-title">企业座机：</td>
                <td class="cell-value"><span>{{personInfo.enterprise.contacts.cellNumber}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="cpl"
           style="margin-bottom: 30px;">
        <div class="cpl-footer">
          <gt-checkbox name="agree"
                       v-validate="'required|trim'"
                       v-model="checked">我已确认账户信息</gt-checkbox>
          <router-link style="color: #377DB8;"
                       class="fr"
                       :to="{name: 'accountCertification'}">账号信息有误？</router-link>
        </div>
      </div>
      <div class="cpl">
        <div class="cpl-header">
          <h2>收件地址</h2>
          <p class="header-tip"><i class="iconfont iconzhuyi-"></i>地址请认真核对，用于后面证书、报告等材料的发放。</p>
          <router-link style="color: #377DB8;flex: 1;text-align: right;font-size:12px;"
                       class="fr"
                       :to="{ name: 'address' }">管理材料收件地址</router-link>
        </div>
        <div class="cpl-body"
             style="border:none;">
          <address-manage-box ref="addressManageBox"></address-manage-box>
        </div>
      </div>
    </article>
    <!-- <confirm-info></confirm-info> -->
  </div>
</template>

<script>
// import { getPersonalInfo } from '@/api/sdk/index'
import AddressManageBox from '@/views/main/app/detection/person/address_manage'

export default {
  name: 'PersonInfo',
  inject: ['sourceData'],
  components: {
    AddressManageBox
  },
  props: {
    personInfo: {
      type: Object,
      defautl () {
        return {}
      }
    }
  },
  data () {
    // console.log(this.sourceData)
    let references = this.sourceData.personal
    return {
      checked: '',
      loading: false,
      // provinceList: [],
      // cityList: [],
      // areaList: [],
      date: '',
      // areaCode: 0,
      // phoneList: [{ label: '中国大陆 +86', value: 0 }],
      // address: {
      //   province: '',
      //   city: '',
      //   area: '',
      //   street: references.street
      // },
      // cnAddress: '',
      references
      // person: {
      //   contacts: {
      //     cellNumber: '',
      //     name: '',
      //     phone: ''
      //   },
      //   enterprise: {
      //     address: '',
      //     enterpriseCode: '',
      //     enterpriseName: ''
      //   },
      //   legalRepresentation: {
      //     idNo: '',
      //     name: ''
      //   }
      // }
    }
  },
  computed: {
    geo () {
      return this.$store.getters.getGeo
    }
  },
  methods: {
    // initInfo () {
    //   getPersonalInfo({}).then(res => {
    //     let record = res.data.data.record
    //     this.person = { ...record }
    //     this.loading = false
    //   })
    // },
    generateParams () {
      // this.$emit('input', this.cnAddress) // 用于展示
    },
    validate () {
      if (!this.checked) this.$message.warning('请确认账户信息!')
      return this.$validator.validateAll()
    }
  },
  created () {
    // this.initInfo()
    // this.initGeo()
  }
}
</script>

<style lang='less' scoped>
.table-wrap {
  padding: 20px;
  table {
    .cell-title {
      color: #666666;
    }
    .cell-value {
      color: #333333;
    }
    td {
      font-size: 14px;
      line-height: 30px;
      span {
        margin-left: 10px;
      }
    }
  }
}
/* form */
.gt-form-item__label {
  width: 100px;
  text-align: left;
}
.gt-form-item__content {
  margin-left: 100px;
}
/deep/.gt-checkbox__label {
  font-size: 14px;
}
.gt-select-input {
  width: 120px;
  margin-right: 10px;
  .gt-select {
    width: 120px;
  }
}
</style>
